import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../constants';
import { useError } from '../../field-error';
import { useFieldAttributes } from '../../services/field-attributes';
import { SignatureUI } from '../../ui/signature';
import { FieldLabelWUT } from '../../ui/field-label';
import { FieldDescriptionWUT } from '../../ui/field-description';
import { getTextInputFieldError } from '../../ui/text-input-field/text-input-field-utils';
import { FieldErrorWUT } from '../../ui/field-error';
export function Signature(props) {
  const {
    id,
    required,
    label,
    hideLabel,
    target,
    description,
    FieldLayout,
    validation,
    error,
    requiredIndicatorType,
    requiredIndicatorPlacement,
    ...rest
  } = props;
  const {
    errorMessage,
    hasError
  } = useError(getTextInputFieldError(validation, error), undefined, FIELD_TYPES.SIGNATURE);
  const {
    labelId,
    inputId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id
  }, /*#__PURE__*/React.createElement(FieldLabelWUT, {
    labelId: labelId,
    required: required,
    label: label,
    hideLabel: hideLabel,
    requiredIndicatorType: requiredIndicatorType,
    requiredIndicatorPlacement: requiredIndicatorPlacement
  }), /*#__PURE__*/React.createElement(SignatureUI, _extends({
    target: target,
    inputId: inputId,
    ariaLabelledBy: labelId,
    ariaDescribedBy: ariaDescribedBy,
    enableUpload: props.uploadEnabled,
    hasError: hasError
  }, rest)), /*#__PURE__*/React.createElement(FieldErrorWUT, {
    id: errorId,
    target: target,
    hasError: hasError,
    errorMessage: errorMessage
  }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
    description: description,
    id: descriptionId
  }));
}
//# sourceMappingURL=signature.js.map